import Swiper from 'swiper/bundle';

const SwiperSelector = '[data-swiper]';
const SwiperDefault = {
    breakpointsInverse: true,
    observer: true
};
window.initSwipers = function () {
    let SliderProduct = false;
    let SwiperProductThumbnails = false;
    $(SwiperSelector).each(function (i , slider) {
        if($(slider).hasClass('swiper-initialized')) {

        }else{
            let SwiperOptions = JSON.parse($(slider).attr('data-swiper')) || {};
            let SwiperCustomPaginationKeys = $(slider).attr('data-pagination-keys') || '';
            if(SwiperCustomPaginationKeys.length){
                SwiperCustomPaginationKeys = SwiperCustomPaginationKeys.split('|');
                if(SwiperCustomPaginationKeys.length){
                    SwiperOptions.pagination = {
                        el: ".swiper-pagination",
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '">' + SwiperCustomPaginationKeys[index] + "</span>";
                        },
                    }
                }
                console.log(SwiperCustomPaginationKeys)
            }

            if($(window).width() < 768) {
                SwiperOptions.autoplay = false;
            }
            if($(slider).hasClass('swiper-product')){
                SliderProduct = slider;
            }else{
                slider.options = $.extend({}, SwiperDefault, SwiperOptions);
                const swiper = new Swiper(slider, slider.options);
                if($(slider).hasClass('swiper-product-thumbnails')){
                    SwiperProductThumbnails = swiper;
                }
            }
        }
    });
    if(SliderProduct) {
        const SwiperOptions = JSON.parse($(SliderProduct).attr('data-swiper')) || {};
        SliderProduct.options = $.extend({}, SwiperDefault, SwiperOptions);
        if(SwiperProductThumbnails){
            SliderProduct.options.thumbs = {
                swiper: SwiperProductThumbnails,
            }
        }
        const swiper = new Swiper(SliderProduct, SliderProduct.options);
    }
}
$(document).ready(function () {
    initSwipers();
});
